<template>
  <div class="row tw-document-list-item"  v-if="noticeTemplate">
    <div class="col-12">
      <div class="d-flex justify-between align-content-center">
        <q-checkbox
            outlined
            dense
            @click="onSelectChange"
            v-model="noticeTemplate.selected"
            :label="$t('task.printDocument.filesName.'+ noticeTemplate.fileName)"
        />

        <div class="d-flex justify-content-between align-items-center">
          <q-btn
              icon="upload_file"
              size="sm"
              padding="xs"
              class="btn btn-sm btn-outline-primary"
              @click="onSendEvent"
          />
          <q-btn
              class="btn btn-sm btn-outline-primary"
              size="sm"
              padding="xs"
              icon="visibility"
              :loading="isLoadingView"
              @click="onViewEvent"
          >
            <template v-slot:loading>
              <q-spinner-facebook />
            </template>
          </q-btn>
          <q-btn
              class="btn btn-sm btn-outline-primary"
              size="sm"
              padding="xs"
              icon="download"
              :loading="isLoadingDownload"
              @click="onDownloadEvent"
          >
            <template v-slot:loading>
              <q-spinner-facebook />
            </template>
          </q-btn>
          <q-btn
              class="btn btn-sm btn-outline-primary"
              size="sm"
              padding="xs"
              icon="list"
              @click="openPackDetail"
              v-if="isPack"
          />
        </div>
      </div>
    </div>

    <div class="col-12" v-if="isPack && opened">
      <q-list padding :display="opened">
        <q-item
            tag="label"
            v-ripple
            v-for="(template, index) in noticeTemplate.items"
            :key="index"
        >
          <q-item-section>
            <PrintDocumentListPackItem
                @child-boolean-changed="updateParentParentBoolean"
                :noticeTemplate="template"
                :notice="noticeTemplate"
            />
          </q-item-section>
        </q-item>
      </q-list>
    </div>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import {NoticeTemplate} from "@/types";
import store from "@/store";
import PrintDocumentListPackItem from "@/components/document/list/PrintDocumentListPackItem.vue";

@Options({
  props: ["noticeTemplate", "index", "reference"],
  components: {PrintDocumentListPackItem}
})
export default class PrintDocumentListItem extends Vue {
  reference: any;
  index?: number
  opened = false;
  noticeTemplate?: NoticeTemplate;
  isLoadingView = false;
  isLoadingDownload = false;

  get isPack() {
    return this.noticeTemplate?.isPack;
  }

  onSelectChange() {
    store.dispatch("printDocumentModule/setTemplateSelected", {
      template: this.noticeTemplate,
      selected: this.noticeTemplate?.selected,
    });
    this.updateParentParentBoolean(false);
  }

  onSendEvent() {
    this.updateParentParentBoolean(true);
    store.dispatch("printDocumentModule/sendTemplate", {
      template: this.noticeTemplate,
    });
  }

  get currentRoute() {
    return this.$router.currentRoute.value.name;
  }

  async onViewEvent() {
    this.isLoadingView = true;
    this.updateParentParentBoolean(true);
    await store.dispatch('printDocumentModule/generateDocument', {
      index: this.index,
      currentRoute: this.currentRoute,
      callback: this.setPreviewTemplate
    })
  }

  setPreviewTemplate(){
    store.dispatch("printDocumentModule/setPreviewTemplate", {
      template: this.noticeTemplate,
      callback: this.viewDocumentResponse,
    });
  }
  viewDocumentResponse() {
    this.isLoadingView = false;
    this.isLoadingDownload = false;
  }

  onDownloadEvent() {
    this.isLoadingDownload = true;
    this.updateParentParentBoolean(true);
    store.dispatch('printDocumentModule/generateDocument', {
      index: this.index,
      currentRoute: this.currentRoute,
      callback: this.downloadFile
    })
  }

  downloadFile(){
    store.dispatch("printDocumentModule/downloadFile", {
      request: {
        resourceUid: this.fileId
      },
      callback: this.downloadDocumentResponse,
    });
  }

  downloadDocumentResponse(response: any) {
    if (response) {
      const { content } = response;
      const fileName = this.noticeTemplate?.fileName || response?.originalFileName; 
      const linkSource = `data:${response.format};base64,${content}`;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = `${fileName}_${this.reference}.pdf`;
      downloadLink.click();
      this.viewDocumentResponse()
    }
  }

  openPackDetail() {
    this.opened = !this.opened;
  }

  updateParentParentBoolean(action: boolean) {
    this.$emit("child-boolean-changed", this.noticeTemplate, action);
  }

  get fileId() {
    return store.state.printDocumentModule.fileDetailFileId
  }
}
</script>

<style scoped>

</style>
